import { getShowSupply, getChainToken } from '@/api/chain'

export default {
  data () {
    return {
      showSupply: false
    }
  },
  methods: {
    // 获取直供入口权限
    async getShowSupply () {
      try {
        const { code, result } = await getShowSupply()
        if (code !== 200) return
        this.showSupply = result.showSupply
      } catch (error) {
        console.log(error.message)
      }
    },
    async getChainToken () {
      try {
        this.isLoading = true
        const { code, result } = await getChainToken()
        if (code !== 200) return
        window.location.href = `${this.showSupply ? process.env.VUE_APP_SUPPLY_RIGHT_URL : process.env.VUE_APP_SUPPLY_URL}?token=${result}`
      } catch (error) {
        console.log(error.message)
      } finally {
        this.isLoading = false
      }
    }
  },
  created () {
    this.getShowSupply()
  }
}